export default {
  development: {
    assets_path: '/',
    site_address: 'http://localhost:3000/',
    site_api: '',
  },
  staging: {
    assets_path: 'https://stagingsite.ascendcap.in/',
    site_address: 'https://stagingsite.ascendcap.in/',
    site_api: '/api',
  },
  qa: {
    assets_path: '/',
    site_address: 'https://stagingsite.ascendcap.in/',
    site_api: '/api',
  },
  production: {
    assets_path: 'https://ascendcap.in/',
    site_address: 'https://ascendcap.in/',
    site_api: '/api',
  },
  test: {
    assets_path: '/',
    site_address: 'https://stagingsite.ascendcap.in/',
    site_api: '/api',
  },
};



// WEBPACK FOOTER //
// ./src/config/env.js